import routes from '../../routes';
import { NavLink as NavLinkRRD } from "react-router-dom";
import { Navbar, Nav, NavItem, NavLink, Container, Collapse } from "reactstrap";
import './assets/navbar.css';
import { useSelector } from 'react-redux';
import { filteredRoutes } from '../../Helpers/filteredRoutes';


const Sidebar = () => {
  
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  if (loading) return null;
    
  const renderIcon = (icon) => {
    return (
      <span className="nav-icon">
        {icon && (icon.match(/\.(png|jpe?g|svg|gif)$/i) ? (
          <img src={icon} alt="" />
        ) : icon ? (
          <i className={icon} />
        ) : null)}
      </span>
    );
  };

  const mainRoutes = filteredRoutes();
  return (
    <Navbar
      className="test-navbar navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <Collapse navbar isOpen={true}>
          <Nav navbar>
            <div className="nav-main">
              {mainRoutes.map((route, index) => (
                <NavItem key={`main-${index}`}>
                  <NavLink
                    to={route.path}
                    tag={NavLinkRRD}
                  >
                    {renderIcon(route.icon)}
                    {route.name}
                  </NavLink>
                </NavItem>
              ))}
            </div>
            
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Sidebar;
